import { Directive, HostListener, Input, ElementRef, AfterViewInit } from '@angular/core';

@Directive({ selector: '[numberic-only]' })
export class NumbericOnlyDirective implements AfterViewInit {
    @Input() minValue = 0;
    @Input() maxValue = 0;
    
    constructor(private _element: ElementRef) { }

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (this.minValue >= 0 && event.key == '-') {
            return event.preventDefault();
        }

        if (event.key == 'Backspace' && this._element.nativeElement.value < 10) {
            this._element.nativeElement.value = 1;
        }
    }

    ngAfterViewInit() {
        $(this._element.nativeElement).blur(function (e) {
            if ($(this).val() === '') {
                $(this).val(this.min);
                return;
            }
            if ($(this).val() < this.min) {
                $(this).val(this.min);
                return;
            }

        });
    }
}
